import { useCallback } from "react";
import axios from "axios";
import { clearStaffSession, hasStaffSession } from "@/lib/staff";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Chiamate admin: sessione staff via cookie httpOnly (withCredentials) oppure token Clerk (window.Clerk).
// Non usa hook di Clerk, così l'area admin funziona anche se l'accesso Google non è disponibile.
export function useApi() {
  return useCallback(
    async (method, path, data) => {
      const staff = hasStaffSession();
      const clerkToken = staff ? null : await window.Clerk?.session?.getToken();
      const headers = clerkToken ? { Authorization: `Bearer ${clerkToken}` } : {};
      try {
        const res = await axios({ method, url: `${API}${path}`, data, headers, withCredentials: true });
        return res.data;
      } catch (e) {
        if (e?.response?.status === 401 && staff) {
          clearStaffSession();
          window.location.assign("/sign-in");
        }
        throw e;
      }
    },
    []
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Si è verificato un errore";
};

const euro = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });
export const fmtEuro = (v) => euro.format(v || 0);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "");

export const LEAD_STATUSES = ["Nuovo", "Contattato", "Sopralluogo Fissato", "Preventivo Inviato", "Chiuso Vinto", "Non Interessato"];
export const QUOTE_STATUSES = ["Bozza", "Inviato", "Accettato", "Rifiutato"];

export const STATUS_STYLES = {
  Nuovo: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Contattato: "bg-sky-50 text-sky-700 border-sky-200",
  "Sopralluogo Fissato": "bg-amber-50 text-amber-700 border-amber-200",
  "Preventivo Inviato": "bg-violet-50 text-violet-700 border-violet-200",
  "Chiuso Vinto": "bg-slate-900 text-white border-slate-900",
  "Non Interessato": "bg-slate-100 text-slate-500 border-slate-200",
  Bozza: "bg-slate-100 text-slate-600 border-slate-200",
  Inviato: "bg-sky-50 text-sky-700 border-sky-200",
  Accettato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rifiutato: "bg-rose-50 text-rose-700 border-rose-200",
};
